import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import CanonicalTag from "@/components/CanonicalTag";
import couplesRoommatesImage from "@/assets/couples-roommates-adu.jpg";
const HowToUseADUCouplesRoommates = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);
  return <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/how-to-use-adu-couples-roommates" />
      <Navigation />
      
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{
          color: '#E4683B'
        }}>
            How to Use Your ADU for Couples or Roommates
          </h1>
          <h2 className="text-3xl font-bold mb-6 text-[#e4683b] md:text-3xl">
            Affordable and Stylish Shared Living
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
            Design a co-living ADU that combines affordability with independence in perfect harmony.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button onClick={openCalendlyModal} className="bg-[#E4683B] hover:bg-[#E4683B]/90 text-white px-8 py-3 text-lg">
              📅 Book & Schedule
            </Button>
            <Button variant="outline" className="border-[#E4683B] text-[#E4683B] bg-white hover:bg-[#E4683B] hover:text-white px-8 py-3 text-lg" onClick={() => window.location.href = '/landing'}>
              📐 What fits my lot?
            </Button>
          </div>
        </div>

        {/* Main Image */}
        <div className="mb-16">
          <img src={couplesRoommatesImage} alt="Shared ADU living space for couples and roommates" className="w-full max-w-4xl mx-auto rounded-lg shadow-lg" />
        </div>

        {/* Layout Essentials Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold mb-8 text-center" style={{
          color: '#E4683B'
        }}>
            Layout Essentials
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-card p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4 text-foreground">Two bedrooms or split-suite design</h3>
              <p className="text-muted-foreground">Private sleeping areas with flexible layout options.</p>
            </div>
            <div className="bg-card p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4 text-foreground">Shared living room and kitchen</h3>
              <p className="text-muted-foreground">Common areas that promote connection while maintaining functionality.</p>
            </div>
            <div className="bg-card p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4 text-foreground">Soundproofed walls for privacy</h3>
              <p className="text-muted-foreground">Enhanced privacy through thoughtful acoustic design.</p>
            </div>
          </div>
        </div>

        {/* Mid-Section CTAs */}
        <div className="text-center mb-16">
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button variant="outline" className="border-[#E4683B] text-[#E4683B] bg-white hover:bg-[#E4683B] hover:text-white px-8 py-3" onClick={() => window.location.href = '/landing'}>
            📐 What fits my lot?
          </Button>
          <Button className="bg-white text-[#E4683B] border border-[#E4683B] hover:bg-[#E4683B] hover:text-white px-8 py-3" onClick={() => window.open('https://udaadu.com/price-roi-report', '_blank')}>
            💰 Get Price & ROI Report
          </Button>
        </div>
        </div>

        {/* Perfect For Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold mb-8 text-center" style={{
          color: '#E4683B'
        }}>
            Perfect For:
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-muted-foreground text-center">
              Young couples, friends sharing housing, or multi-generational siblings
            </p>
          </div>
        </div>

        {/* Financial Upside Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold mb-8 text-center" style={{
          color: '#E4683B'
        }}>
            Financial Upside
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-muted-foreground text-center">
              Shared rent makes ADUs accessible and financially smart—great for investment or lifestyle choice.
            </p>
          </div>
        </div>

        {/* Bottom CTAs */}
        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="outline" className="border-[#E4683B] text-[#E4683B] hover:bg-[#E4683B] hover:text-white px-8 py-3" onClick={() => window.open('/our-work', '_blank')}>
              🏡 Our Portfolio
            </Button>
            <Button variant="outline" className="border-[#E4683B] text-[#E4683B] hover:bg-[#E4683B] hover:text-white px-8 py-3" onClick={() => window.open('/faq', '_blank')}>
              ❓ Our FAQ
            </Button>
          </div>
        </div>
      </div>

      <Footer />

      {/* Calendly Modal */}
      <Dialog open={showCalendly} onOpenChange={setShowCalendly}>
        <DialogContent className="max-w-4xl max-h-[80vh] p-0">
          <div className="relative w-full h-[600px]">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100">
              ✕
            </button>
            <iframe src="https://calendly.com/udaadu" width="100%" height="100%" frameBorder="0" title="Schedule a consultation" />
          </div>
        </DialogContent>
      </Dialog>
    </div>;
};
export default HowToUseADUCouplesRoommates;